import { useEffect, useState } from "react";

export const useIsMobile = (minWidth = 768) => {
    const [isMobile, setIsMobile] = useState<boolean | undefined>(undefined);

    const onResize = () => {
        setIsMobile(window.innerWidth <= minWidth);
    };

    useEffect(() => {
        onResize();

        window.addEventListener("resize", onResize);

        return () => {
            window.removeEventListener("resize", onResize);
        };
    }, []);

    return isMobile;
};
